export const PAINTING_PLAN_ADMIN_BASE = '/app/comercial/admin/plano-pintura';
export const DEFAULT_PAINTING_PLAN_ADMIN_PATH = `${PAINTING_PLAN_ADMIN_BASE}/catalogos-tecnicos/tintas-e-ral`;
const TAB_SLUGS = {
    catalogos: 'catalogos-tecnicos',
    grupos: 'grupos',
    padroes: 'padroes-icavi',
    regras: 'regras-de-atribuicao',
};
const TAB_BY_SLUG = Object.fromEntries(Object.entries(TAB_SLUGS).map(([tab, slug]) => [slug, tab]));
const CATALOG_SLUGS = {
    ink: 'tintas-e-ral',
    thickness: 'micragens',
    characteristic: 'caracteristicas',
    finish: 'acabamentos',
    surfacePreparation: 'preparacoes-de-superficie',
    cleaningMethod: 'metodos-de-limpeza',
};
const CATALOG_BY_SLUG = Object.fromEntries(Object.entries(CATALOG_SLUGS).map(([type, slug]) => [
    slug,
    type,
]));
export function tabFromSectionSlug(section) {
    if (!section)
        return null;
    return TAB_BY_SLUG[section] ?? null;
}
export function catalogTypeFromSlug(slug) {
    if (!slug)
        return null;
    return CATALOG_BY_SLUG[slug] ?? null;
}
export function buildPaintingPlanAdminPath(tab, catalogType = 'ink') {
    const section = TAB_SLUGS[tab];
    if (tab === 'catalogos') {
        return `${PAINTING_PLAN_ADMIN_BASE}/${section}/${CATALOG_SLUGS[catalogType]}`;
    }
    return `${PAINTING_PLAN_ADMIN_BASE}/${section}`;
}
export function resolvePaintingPlanAdminRoute(section, catalogSlug) {
    const tab = tabFromSectionSlug(section);
    if (!tab) {
        return { tab: 'catalogos', catalogType: 'ink', redirectTo: DEFAULT_PAINTING_PLAN_ADMIN_PATH };
    }
    if (tab !== 'catalogos') {
        if (catalogSlug) {
            return { tab, catalogType: 'ink', redirectTo: buildPaintingPlanAdminPath(tab) };
        }
        return { tab, catalogType: 'ink', redirectTo: null };
    }
    if (!catalogSlug) {
        return {
            tab,
            catalogType: 'ink',
            redirectTo: buildPaintingPlanAdminPath('catalogos', 'ink'),
        };
    }
    const catalogType = catalogTypeFromSlug(catalogSlug);
    if (!catalogType) {
        return {
            tab,
            catalogType: 'ink',
            redirectTo: buildPaintingPlanAdminPath('catalogos', 'ink'),
        };
    }
    return { tab, catalogType, redirectTo: null };
}
